import type { Event } from "@bugsnag/js";

const SENSITIVE_PARAMS = new Set([
  "scan_type",
  "scan_type_id",
  "modality",
  "modality_id",
  "body_part",
  "body_parts",
  "body_part_id",
  "body_part_ids",
  "search_inputs",
  "area",
  "location",
  "postcode",
  "lat",
  "lng",
  "partner_return_url",
  "q",
]);

const QUERY_PAIR = /([?&])([^=&#]+)=([^&#]*)/g;

// Reduces `body_parts[]`, `body_parts%5B%5D` and `search[area]` to the param name.
const paramName = (rawKey: string): string =>
  rawKey
    .replace(/%5B/gi, "[")
    .replace(/%5D/gi, "]")
    .replace(/\[\]$/, "")
    .replace(/^.*\[([^\]]*)\]$/, "$1");

const scrub = <T>(value: T): T | string =>
  typeof value === "string"
    ? value.replace(QUERY_PAIR, (match, separator: string, key: string) =>
        SENSITIVE_PARAMS.has(paramName(key))
          ? `${separator}${key}=[FILTERED]`
          : match
      )
    : value;

export function scrubEvent(event: Event): void {
  if (event.request) event.request.url = scrub(event.request.url);
  event.context = scrub(event.context);
  event.breadcrumbs.forEach((breadcrumb) => {
    Object.keys(breadcrumb.metadata).forEach((key) => {
      breadcrumb.metadata[key] = scrub(breadcrumb.metadata[key]);
    });
  });
}

export const bugsnagPrivacyOptions = {
  collectUserIp: false,
  onError: scrubEvent,
};
